import WidgetsMgr from 'widgets/widgetsMgr';
import TrackLink from './widgets/TrackLink';

WidgetsMgr.addWidgetsList('gtm.analytics.core', () => [['trackLink', TrackLink]]);

const hasContext = (context: string) => window.contexts.includes(context);

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('orderconfirmation'),
    load: () =>
        Promise.all([import('./widgets/EventSender').then(d => d.default)]).then(deps => {
            const [EventSender] = deps;

            return {
                listId: 'gtm.analytics.widgets',
                widgetsDefinition: () => [['eventSender', EventSender]]
            };
        })
});
